import { render } from "./FormCheckboxGroup.vue?vue&type=template&id=723b202a"
import script from "./FormCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./FormCheckboxGroup.vue?vue&type=script&lang=js"

import "./FormCheckboxGroup.vue?vue&type=style&index=0&id=723b202a&lang=scss"
script.render = render

export default script